import { Record } from 'immutable';
import { server } from '../constants/SiteVariables';

export default class MerchantRecord extends Record({
  id: null,
  platform: '',
  name: '',
  supports_standalone_csr: null,
  support_email: '',
  active_promo: {},
  public_key: '',
  url: '',
  restricted_industry: null,
  slug: '',
  learn_more_link: '',
  default_checkout_method: null
}) {
  
}
